































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import {
	EntityLocation,
	FeedTank,
	Product,
	Tank,
	Vat,
	WaterMeter,
	WaterMonitor,
	WaterTank,
} from '@/api';
import InformationRow from '@/components/display/information-row.vue';
import { ProductOrdwayAttributes } from '@/models/ordway';
import BillingSetupButton from '@/components/billing-setup-form/billing-setup-button.vue';
import { Validations } from 'vuelidate-property-decorators';
import { validationMixin } from 'vuelidate';
import { mixins } from 'vue-class-component';
import { decimal, maxValue, minValue, required } from 'vuelidate/lib/validators';
import { BvModalEvent } from 'bootstrap-vue';
import LocationInput from '@/components/form pickers/LocationInput.vue';
import { EntityLocationService } from '@/services/entity-location-service';
import Toast from '@/components/display/toast.vue';
import { cloneDeep } from 'lodash';

@Component({
	components: { LocationInput, InformationRow },
})
export default class LocationRow extends mixins(validationMixin) {
	@Prop({ required: true })
	public entity!: Vat | Tank | WaterMeter | WaterTank | WaterMonitor | FeedTank;

	@Prop({ required: true })
	public entityType!: string;

	@Validations()
	private validations() {
		return {
			entityLocation: {
				latitude: { required, decimal, minValue: minValue(-90), maxValue: maxValue(90) },
				longitude: { required, decimal, minValue: minValue(-180), maxValue: maxValue(180) },
			},
		};
	}

	@Watch('entity')
	public onEntityChanged() {
		this.entityLocation = cloneDeep(
			this.entity?.entitylocation ?? {
				latitude: 0,
				longitude: 0,
				entityId: this.entity.id,
				entityType: this.entityType,
			},
		);
	}

	private readonly toast: Toast = new Toast();
	private readonly modalId: string = `updateLocationModal${Math.random()}`;

	private submitting: boolean = false;

	private entityLocation: EntityLocation = cloneDeep(
		this.entity?.entitylocation ?? {
			latitude: 0,
			longitude: 0,
			entityId: this.entity.id,
			entityType: this.entityType,
		},
	);

	private get locationString(): string {
		return `${this.entity.entitylocation?.latitude ?? 0}, ${this.entity.entitylocation?.longitude ??
			0}`;
	}

	private get locationUrl(): string {
		return `https://maps.google.com/?q=${this.entity.entitylocation?.latitude ?? 0},${this.entity
			.entitylocation?.longitude ?? 0}`;
	}

	private get entityName(): string {
		let name: string | undefined;
		if ('label' in this.entity) name = this.entity.label;
		else if ('name' in this.entity) name = this.entity.name;
		return name ?? 'Unknown Entity';
	}

	private async saveLocation(event: BvModalEvent): Promise<void> {
		this.$v.$touch();
		if (this.$v.$invalid) {
			event.preventDefault();
			return;
		}

		this.submitting = true;
		const response: void | {
			errorMessage: string;
		} = await EntityLocationService.handleEntityLocation(
			this.entityLocation,
			this.entity.entitylocation ?? null,
		);
		if (response && 'errorMessage' in <Object>response) {
			this.toast.makeToast(response.errorMessage, 'Failed Saving Location', 'danger');
			event.preventDefault();
		} else {
			this.entity.entitylocation = this.entityLocation;
		}
		this.submitting = false;
	}
}
